import React, { useEffect } from 'react';
import Header from '../components/Header';
import ProductionPricing from '../components/ProductionPricing';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const ProductionPricingPage = () => {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Immediately show all fade-in sections on this page
    // (no IntersectionObserver needed since content should be visible on load)
    setTimeout(() => {
      const sections = document.querySelectorAll('.fade-in-section');
      sections.forEach(section => {
        section.classList.add('animate-in');
      });
    }, 100);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      <main>
        <ProductionPricing />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default ProductionPricingPage;
